export default __webpack_public_path__ + "static/media/devops.0a1da726.jpg";